import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-slider--right-2",
  "use": "icon-slider--right-2-usage",
  "viewBox": "0 0 11 10",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 10\" id=\"icon-slider--right-2\"><path d=\"m6.645 9.51-.96-.93L8.55 5.43H0V4.08h8.55L5.685.93l.96-.93 4.29 4.755-4.29 4.755Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol